module.exports = __webpack_public_path__ + "media/images/article/2022_02-16ea6fb2603a05883de76793af9a53fa.png";